import React, { useEffect, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Checkbox, Image } from "antd-mobile";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";

const Manage: React.FC<{
	agentRoleData: Record<string, any>;
	onVisiblePopup: (visible: boolean) => void;
	onSubmit: (params: {}) => void;
}> = ({ agentRoleData, onVisiblePopup, onSubmit }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const [value, setValue] = useState(["look"]);
	useEffect(() => {
		let newValue = [];
		for (const key in agentRoleData.data) {
			newValue.push(key);
		}
		setValue(newValue);
	}, [agentRoleData]);

	const onSubmitHandle = () => {
		const params: any = {
			id: agentRoleData.id,
		};
		let agentRole: any = {
			look: 1,
		};
		for (let index = 0; index < value.length; index++) {
			const element = value[index];
			if (!isEmpty(element)) {
				agentRole[element] = 1;
			}
		}
		params["agentRole"] = JSON.stringify(agentRole);
		onSubmit(params);
		onVisiblePopup(false);
	};

	return (
		<div className={classes.manageNumbers}>
			<header>
				<div
					className="closeIcon"
					onClick={() => {
						onVisiblePopup(false);
					}}
				>
					<Image
						src={require("@/assets/images/icons/back.png")}
						width={20}
						height={18}
					/>
				</div>
				<p>{t("Manage")}</p>
				<div
					className="determine"
					onClick={() => {
						onSubmitHandle();
					}}
				>
					{t("Save")}
				</div>
			</header>
			<Checkbox.Group
				value={value}
				onChange={(v) => {
					setValue(v as string[]);
				}}
			>
				<ul>
					<li>
						<p>{t("RechargeProportional")}</p>
						<Checkbox value={"rechargeAndWithdraw"}></Checkbox>
					</li>
					<li>
						<p>{t("RemarkDeposit")}</p>
						<Checkbox value={"remakeAndDeposit"}></Checkbox>
					</li>
					<li>
						<p>{t("GoLookData")}</p>
						<Checkbox disabled value={"look"}></Checkbox>
					</li>
				</ul>
			</Checkbox.Group>

			<div
				onClick={() => {
					onVisiblePopup(false);
				}}
				className="cancel"
			>
				<span>{t("Cancel")}</span>
			</div>
		</div>
	);
};

export default Manage;

const useStyles = createUseStyles({
	manageNumbers: {
		display: "flex",
		flexDirection: "column",
		height: "54vh",
		borderTopLeftRadius: pxToRem(10),
		borderTopRightRadius: pxToRem(10),
		backgroundColor: "#1E212A",
		"& header": {
			position: "relative",
			height: pxToRem(58),
			lineHeight: pxToRem(58),
			textAlign: "center",
			fontSize: pxToRem(15),
			color: "#FFFFFF",
			borderBottom: "1px solid #2F3A62",
			"& .closeIcon": {
				position: "absolute",
				top: "50%",
				left: pxToRem(15),
				transform: "translateY(-50%)",
			},
			"& .determine": {
				position: "absolute",
				top: "50%",
				right: pxToRem(14),
				color: "#4B6DE3",
				transform: "translateY(-50%)",
			},
		},
		"& ul": {
			flex: 1,
			overflowY: "auto",

			"& >li": {
				height: pxToRem(68),
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(20),
					right: pxToRem(30),
				},
				justifyContent: "space-between",
				borderBottom: "1px solid #2F3A62",
				"& p": {
					flex: 1,
					fontSize: pxToRem(14),
					fontWeight: "400",
					color: "#FFFFFF",
					overflow: "hidden",
				},
			},
		},
		"& .cancel": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: pxToRem(88),
			color: "#FF6161",
			fontSize: pxToRem(18),
			fontWeight: "500",
		},
	},
});
